<template>
    <div class="ipBackups_box">
        <v-header></v-header>
        <div class="mbx">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }" alt="小查线索">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/ipBackups" alt="IP报备单位名称">IP报备单位名称</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="ipBackups_dom">
            <!-- <table class="tableClass" border="0" cellspacing="" cellpadding="">
                <tr class="grey">
                    <td style="width: 50px;">序号</td>
                    <td style="width: 80px">代码号</td>
                    <td>报备单位名称</td>
                    <td>许可证号</td>
                    <td>企业侧备案URL链接地址</td>
                    <td style="width:300px">咨询电话</td>
                </tr>
                <tr class="white" v-for="(item,index) in tableData" :key="index">
                    <td class="class1">{{index+1}}</td>
                    <td class="class2">{{item.code}}</td>
                    <td class="class3">{{item.companyName}}</td>
                    <td class="class2">{{item.license == null? '暂无':item.license}}</td>
                    <td class="class4">
                        <a v-if="item.webUrl != '-'" :href="item.webUrl" target="_blank" :alt="item.companyName">{{item.webUrl}}</a>
                        <span v-else>暂无</span>
                    </td>
                    <td class="class5" v-if="item.phone == ''">暂无</td>
                    
                    <td class="class5" v-else>
                        <p v-for="(item2,index2) in item.phone.split(';')" :key="index2" @click="copyFn(item2)">{{item2}}</p>
                    </td>
                </tr>
            </table> -->
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="code" label="代码号" width="100px"></el-table-column>
                <el-table-column prop="companyName" label="报备单位名称"></el-table-column>
                <el-table-column label="许可证号" width="80px">
                    <template slot-scope="scope">
                        <p v-if="scope.row.license == null">暂无</p>
                        <p v-else>{{scope.row.license}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="企业侧备案URL链接地址">
                    <template slot-scope="scope">
                        <p v-if="scope.row.webUrl == null">暂无</p>
                        <p v-else>
                            <a :href="scope.row.webUrl" target="_blank" :alt="scope.row.companyName">{{scope.row.webUrl}}</a>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="企业侧备案URL链接地址">
                    <template slot-scope="scope">
                        <p v-for="(item2,index2) in scope.row.phone.split(';')" :key="index2" @click="copyFn(item2)">{{item2}}</p>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="upLoadData.n"
                    :page-size="10"
                    layout="total,prev,pager,next,jumper"
                    :total="total">
                </el-pagination>
            </div>
            <textarea id="copy"></textarea>
        </div>
    </div>
</template>
<script>
import vHeader from './common/header.vue'
export default {
    data(){
        return{
            currentPage1:1,
            total:0,
            upLoadData:{
                n:1
            },
            tableData:[]
        }
    },
    components:{
        vHeader
    },
    methods:{
        copyFn(a){
            var copy = document.getElementById('copy');
            console.log(a);
            copy.value = a;
            //调用选中，执行复制命令
            copy.select();
            document.execCommand('copy')
            this.$message.success("复制成功");
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.upLoadData.n = parseInt(val);
            this.getIpReport();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.upLoadData.n = parseInt(val);
            this.getIpReport();
        },
        getIpReport(){
            var _this = this;
            this.getRequest('api/clue/ipReport',this.upLoadData).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    _this.total = data.obj.total;
                    _this.tableData = data.obj.list;
                }
            })
        }
    },
    mounted(){
        this.getIpReport();
    }
}
</script>
<style lang="scss" scoped>
.class1{
    width: 27px;
}
.class2{
    width: 50px;
}
.class3{
    width: 164px;
}
.class4{
    width: 200px;
}
.class5{
    width: 50%;
}
#copy{
    position: fixed;
    left: -2000px;
    top: 0;
}
body {
    background-color: #F0F2F5;
}

.ipBackups_box{
    width: 100%;
    height: auto;
}

.mbx{
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    cursor: default;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    a{
        cursor: default !important;
    }
}

.ipBackups_dom{
    height: auto;
    margin: 0 auto;
    padding: 10px;
    background-color: #fff;
    box-sizing: border-box;
    cursor: default;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    >table.tableClass{
        width: 100%;
        height: auto;
        background-color: #e9ecef;
        >tr.white{
            width: 100%;
            height: 40px;
            background-color: #fff;
            font-size: 14px;
            color: #333333;
            text-align: center;
            td.blue{
                color: #4192FE;
                a{
                    color: #4192FE;
                    text-decoration: none;
                }
            }
        }
        >tr.grey{
            width: 100%;
            height: 50px;
            background-color: #e9ecef;
            font-size: 16px;
            color: #495057;
            text-align: center;
            td.blue{
                color: #4192FE;
                a{
                    color: #4192FE;
                    text-decoration: none;
                }
            }
        }
    }
    >div.pagination{
        width: 100%;
        height: 40px;
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ipBackups.vue